import {z} from 'zod';

import {latitudeSchema} from './latitudeSchema';
import {longitudeSchema} from './longitudeSchema';

export const lngLatSchema = z.tuple([longitudeSchema, latitudeSchema]);
